const CHART_TOP = 10
const CHART_BOTTOM = 338

function isMobileChart(svg) {
  const vb = svg.viewBox?.baseVal
  const width = vb?.width || Number.parseFloat(svg.getAttribute('width')) || 585
  return width <= 320 || svg.dataset.mobileChart === '1'
}

function chartMetrics(svg) {
  if (isMobileChart(svg)) {
    return {
      plotLeft: 4,
      plotRight: 242,
      tvlMin: 110_000_000,
      tvlMax: 120_000_000,
      rangeStart: Date.UTC(2026, 7, 29, 0, 0, 0),
      rangeEnd: Date.UTC(2026, 8, 4, 23, 59, 59),
    }
  }
  return {
    plotLeft: 4,
    plotRight: 537,
    tvlMin: 114_000_000,
    tvlMax: 124_000_000,
    rangeStart: Date.UTC(2026, 7, 18, 0, 0, 0),
    rangeEnd: Date.UTC(2026, 7, 24, 23, 59, 59),
  }
}

function parseSeriesPoints(svg) {
  const series = svg.querySelector('g[clip-path] path[fill="none"][stroke^="url"]')
  if (!series) return []
  const d = series.getAttribute('d') || ''
  const points = []
  const re = /[ML]\s*([-\d.]+)[,\s]+([-\d.]+)/gi
  let match
  while ((match = re.exec(d))) {
    points.push({ x: Number(match[1]), y: Number(match[2]) })
  }
  return points
}

function nearestPoint(points, svgX) {
  if (!points.length) return null
  let best = points[0]
  let bestDist = Math.abs(best.x - svgX)
  for (let i = 1; i < points.length; i += 1) {
    const dist = Math.abs(points[i].x - svgX)
    if (dist < bestDist) {
      best = points[i]
      bestDist = dist
    }
  }
  return best
}

function tvlFromY(y, metrics) {
  const t = (CHART_BOTTOM - y) / (CHART_BOTTOM - CHART_TOP)
  return metrics.tvlMin + t * (metrics.tvlMax - metrics.tvlMin)
}

function dateFromX(x, points, metrics) {
  if (!points.length) return new Date(metrics.rangeStart)
  const minX = points[0].x
  const maxX = points[points.length - 1].x
  const t = maxX === minX ? 0 : (x - minX) / (maxX - minX)
  return new Date(metrics.rangeStart + t * (metrics.rangeEnd - metrics.rangeStart))
}

function formatDate(date) {
  const m = date.getUTCMonth() + 1
  const d = date.getUTCDate()
  const y = date.getUTCFullYear()
  const hh = String(date.getUTCHours()).padStart(2, '0')
  const mm = String(date.getUTCMinutes()).padStart(2, '0')
  return `${m}/${d}/${y} ${hh}:${mm}`
}

function formatTvl(value) {
  return `${value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} LIT`
}

function clientToSvg(svg, clientX, clientY) {
  const ctm = svg.getScreenCTM()
  if (!ctm) {
    const rect = svg.getBoundingClientRect()
    const vb = svg.viewBox?.baseVal
    const width = vb?.width || Number(svg.getAttribute('width')) || 585
    const height = vb?.height || Number(svg.getAttribute('height')) || 360
    return {
      x: ((clientX - rect.left) / rect.width) * width,
      y: ((clientY - rect.top) / rect.height) * height,
    }
  }
  const point = svg.createSVGPoint()
  point.x = clientX
  point.y = clientY
  const local = point.matrixTransform(ctm.inverse())
  return { x: local.x, y: local.y }
}

function svgToHost(svg, host, svgX, svgY) {
  const ctm = svg.getScreenCTM()
  const hostRect = host.getBoundingClientRect()
  if (!ctm) {
    const svgRect = svg.getBoundingClientRect()
    const vb = svg.viewBox?.baseVal
    const width = vb?.width || Number(svg.getAttribute('width')) || 585
    const height = vb?.height || Number(svg.getAttribute('height')) || 360
    return {
      x: svgRect.left - hostRect.left + (svgX / width) * svgRect.width,
      y: svgRect.top - hostRect.top + (svgY / height) * svgRect.height,
    }
  }
  const point = svg.createSVGPoint()
  point.x = svgX
  point.y = svgY
  const screen = point.matrixTransform(ctm)
  return {
    x: screen.x - hostRect.left,
    y: screen.y - hostRect.top,
  }
}

function ensureCrosshair(svg) {
  let path = svg.querySelector('path.staking-tvl-crosshair')
  if (!path) {
    path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path.setAttribute('class', 'staking-tvl-crosshair')
    path.setAttribute('fill', 'none')
    path.setAttribute('stroke', '#b7b9be')
    path.setAttribute('stroke-dasharray', '4,2')
    path.style.display = 'none'
    svg.appendChild(path)
  }
  return path
}

function ensureTooltip(host) {
  let tip = host.querySelector('.staking-tvl-tooltip')
  if (!tip) {
    tip = document.createElement('div')
    tip.className = 'staking-tvl-tooltip z-10! shadow-elevate-popover'
    tip.innerHTML = `
      <div class="staking-tvl-tooltip-inner relative flex min-w-[250px] flex-col gap-1 p-4 before:absolute before:top-0 before:left-0 before:h-full before:w-0.5 before:bg-up">
        <div class="staking-tvl-tooltip-date text-ink"></div>
        <div class="staking-tvl-tooltip-row flex justify-between">
          <span class="text-dim">TVL</span>
          <span class="staking-tvl-tooltip-value text-ink"></span>
        </div>
      </div>
    `
    host.appendChild(tip)
  }
  tip.style.display = 'none'
  tip.style.position = 'absolute'
  tip.style.top = '0'
  tip.style.left = '0'
  tip.style.right = 'auto'
  tip.style.bottom = 'auto'
  return tip
}

function updateTooltip(tip, host, svg, point, points, metrics) {
  const dateEl = tip.querySelector('.staking-tvl-tooltip-date')
  const valueEl = tip.querySelector('.staking-tvl-tooltip-value')
  if (dateEl) dateEl.textContent = formatDate(dateFromX(point.x, points, metrics))
  if (valueEl) valueEl.textContent = formatTvl(tvlFromY(point.y, metrics))

  const pos = svgToHost(svg, host, point.x, point.y)
  const tipWidth = tip.offsetWidth || 260
  const tipHeight = tip.offsetHeight || 80
  const hostWidth = host.clientWidth
  let left = pos.x + 18
  let top = pos.y - tipHeight / 2
  if (left + tipWidth > hostWidth - 8) left = pos.x - tipWidth - 18
  if (left < 8) left = 8
  if (left + tipWidth > hostWidth - 8) {
    left = Math.max(8, hostWidth - tipWidth - 8)
  }
  if (top < 8) top = 8
  if (top + tipHeight > host.clientHeight - 8) {
    top = Math.max(8, host.clientHeight - tipHeight - 8)
  }
  tip.style.transform = `translate3d(${Math.round(left)}px, ${Math.round(top)}px, 0px)`
}

export function startTvlChartInteraction(root = document) {
  const host = root.querySelector(
    '.staking-page .staking-tvl-chart .echarts-for-react'
  )
  const svg = host?.querySelector('svg')
  if (!host || !svg) return () => {}

  const metrics = chartMetrics(svg)
  const points = parseSeriesPoints(svg)
  const crosshair = ensureCrosshair(svg)
  const tip = ensureTooltip(host)
  let pinned = false

  const showAt = (clientX, clientY) => {
    const local = clientToSvg(svg, clientX, clientY)
    if (
      local.x < metrics.plotLeft ||
      local.x > metrics.plotRight ||
      local.y < CHART_TOP ||
      local.y > CHART_BOTTOM + 20
    ) {
      return false
    }
    const point = nearestPoint(points, local.x)
    if (!point) return false
    const x = Math.round(point.x) + 0.5
    crosshair.setAttribute('d', `M${x} ${CHART_BOTTOM}L${x} ${CHART_TOP}`)
    crosshair.style.display = 'block'
    tip.style.display = 'block'
    updateTooltip(tip, host, svg, point, points, metrics)
    return true
  }

  const hide = () => {
    pinned = false
    crosshair.style.display = 'none'
    tip.style.display = 'none'
  }

  const onPointerMove = (event) => {
    if (pinned) return
    if (event.pointerType === 'mouse' || event.buttons > 0) {
      showAt(event.clientX, event.clientY)
    }
  }

  const onPointerDown = (event) => {
    if (showAt(event.clientX, event.clientY)) {
      pinned = true
    }
  }

  const onPointerLeave = () => {
    if (!pinned) hide()
  }

  const onDocumentPointerDown = (event) => {
    if (!pinned) return
    if (host.contains(event.target)) return
    hide()
  }

  const onKeyDown = (event) => {
    if (event.key === 'Escape' && pinned) hide()
  }

  host.addEventListener('pointermove', onPointerMove)
  host.addEventListener('pointerdown', onPointerDown)
  host.addEventListener('pointerleave', onPointerLeave)
  document.addEventListener('pointerdown', onDocumentPointerDown)
  window.addEventListener('keydown', onKeyDown)

  return () => {
    host.removeEventListener('pointermove', onPointerMove)
    host.removeEventListener('pointerdown', onPointerDown)
    host.removeEventListener('pointerleave', onPointerLeave)
    document.removeEventListener('pointerdown', onDocumentPointerDown)
    window.removeEventListener('keydown', onKeyDown)
    crosshair.remove()
    tip.remove()
  }
}
